'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Nonselected(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M0.00064 192.640399A192.19176 192.19176 0 0 1 192.640399 0.00064h638.719202A192.19176 192.19176 0 0 1 1023.99936 192.640399v638.719202A192.19176 192.19176 0 0 1 831.359601 1023.99936H192.640399A192.19176 192.19176 0 0 1 0.00064 831.359601V192.640399z m63.99992-0.255999v639.2312C64.00056 902.591512 121.472488 959.99944 192.3844 959.99944h639.2312A128.31984 128.31984 0 0 0 959.99944 831.6156V192.3844A128.31984 128.31984 0 0 0 831.6156 64.00056H192.3844A128.31984 128.31984 0 0 0 64.00056 192.3844z' })
  );
}
Nonselected.displayName = 'Nonselected';

module.exports = Nonselected;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/nonselected.js
// module id = 193
// module chunks = 0